export default __webpack_public_path__ + "static/media/my-quotes.a27a578d.png";